import { useTranslation } from 'react-i18next'
import { landingAssetsForLocale } from '../config/landingAssets'

export default function EmotionalClosingSection() {
  const { t, i18n } = useTranslation('landingPage')
  const assets = landingAssetsForLocale(i18n.language)

  return (
    <section className='relative overflow-hidden px-4 py-[70px]'>
      <img
        src={assets.blurredBackground}
        alt=''
        className='absolute inset-0 h-full w-full object-cover'
        loading='lazy'
        aria-hidden='true'
      />

      <div className='relative text-center'>
        <p className='text-gray-12 whitespace-pre-line text-base font-normal leading-relaxed'>
          {t('emotionalClosing.paragraphs')}
        </p>
      </div>
    </section>
  )
}
